// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3oG_C","footer":"ModalError_footer__93q21"};